import React from 'react';
import './ProgressBar.scss';
export function ProgressBar({ value, total }) {
    const cssProps = {
        '--progress': `${value > total ? 100 : (value / total) * 100}%`,
    };
    return (React.createElement("div", { className: "progress-bar", style: cssProps },
        React.createElement("div", { className: "progress-bar__progress" })));
}
